import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as IssueStore from '../reducers/issue-store.reducer';
import * as IssueSelectors from '../selectors/issue-store.selectors';

@Injectable()
export class IssueStoreFacade {
  constructor(private readonly store: Store<IssueStore.State>) {}

  getAnalysisIssuesByIds$ = (ids: string[], filterOutInternal = true) =>
    this.store.pipe(
      select(IssueSelectors.selectMultipleIssues(ids, filterOutInternal))
    );

  selectSingleIssue$ = (id: string) =>
    this.store.pipe(select(IssueSelectors.selectSingleIssue(id)));

  public selectaAllIssues$ = this.store.pipe(
    select(IssueSelectors.selectaAllIssues)
  );
}
